import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation, Navigate } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";
import {
  getEventoVisibleByIdParaSocio,
  hidratarEventosPublicos,
} from "@/data/adminEventosStore";
import { RESUMEN } from "@/constants/testIds";

export default function ResumenCompra() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [hidratado, setHidratado] = useState(false);
  useEffect(() => {
    hidratarEventosPublicos().finally(() => setHidratado(true));
  }, []);
  const evento = getEventoVisibleByIdParaSocio(id);
  const seleccion = location.state;

  if (!evento) {
    if (!hidratado) return null;
    return <Navigate to="/app" replace />;
  }

  if (!seleccion) {
    return <Navigate to={`/app/eventos/${id}/seleccion-mesa`} replace />;
  }

  const { mesa, cantidad, precio, total } = seleccion;
  const fmt = (n) => `$${n.toLocaleString("es-MX")} MXN`;

  const filas = [
    { label: "Evento", value: evento.nombre, testId: RESUMEN.evento },
    { label: "Mesa", value: `Mesa ${mesa}`, testId: RESUMEN.mesa },
    { label: "Cantidad de boletos", value: `${cantidad}`, testId: RESUMEN.cantidad },
    { label: "Precio por boleto", value: precio, testId: RESUMEN.precio },
  ];

  return (
    <div data-testid={RESUMEN.screen} className="flex flex-col gap-6">
      <button
        type="button"
        onClick={() => navigate(`/app/eventos/${evento.id}/seleccion-mesa`)}
        aria-label="Regresar"
        className="self-start inline-flex items-center gap-2 rounded-full pl-2 pr-4 py-2 text-sm font-medium border hairline bg-card text-foreground hover:bg-muted transition-colors"
      >
        <span className="w-7 h-7 grid place-items-center rounded-full bg-primary/10 dark:bg-accent/15 text-primary dark:text-accent">
          <ArrowLeft className="w-4 h-4" strokeWidth={2} />
        </span>
        Regresar
      </button>

      <header className="animate-fade-up">
        <span className="overline text-accent">Casi listo</span>
        <h1 className="mt-3 font-heading text-3xl sm:text-4xl tracking-tight text-foreground">
          Resumen de compra
        </h1>
      </header>

      <section className="rounded-2xl border hairline bg-card overflow-hidden shadow-soft animate-fade-up delay-100">
        <ul className="flex flex-col">
          {filas.map((f, i) => (
            <li
              key={f.label}
              className={
                "flex items-center justify-between gap-4 px-6 py-4" +
                (i < filas.length - 1 ? " border-b hairline" : "")
              }
            >
              <span className="text-sm text-muted-foreground">{f.label}</span>
              <span
                data-testid={f.testId}
                className="text-sm text-foreground text-right"
              >
                {f.value}
              </span>
            </li>
          ))}
          <li className="flex items-center justify-between gap-4 px-6 py-5 bg-muted/30">
            <span className="overline text-muted-foreground">Total</span>
            <span
              data-testid={RESUMEN.total}
              className="font-heading text-2xl text-primary dark:text-accent"
            >
              {fmt(total)}
            </span>
          </li>
        </ul>
      </section>

      <div className="flex flex-col gap-3 animate-fade-up delay-200">
        <button
          type="button"
          data-testid={RESUMEN.btnPago}
          onClick={() => navigate(`/app/eventos/${evento.id}/pago`, { state: seleccion })}
          className="w-full inline-flex items-center justify-center gap-2 rounded-full px-6 py-4 text-sm font-semibold uppercase tracking-wide bg-primary text-primary-foreground dark:bg-accent dark:text-accent-foreground ring-1 ring-primary/20 dark:ring-accent/40 shadow-soft hover:opacity-95 active:scale-[0.99] transition-all"
        >
          Continuar al pago
          <ChevronRight className="w-4 h-4" strokeWidth={2} />
        </button>
        <button
          type="button"
          data-testid={RESUMEN.btnCambiar}
          onClick={() => navigate(`/app/eventos/${evento.id}/seleccion-mesa`)}
          className="w-full inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-medium border hairline bg-card text-foreground hover:bg-muted transition-colors"
        >
          Cambiar mesa
        </button>
      </div>
    </div>
  );
}
